import { setAboutData } from '../reducers/about';
import { setContactusData } from '../reducers/contactus';
import { getAboutPageData, formatAboutPageData } from '../../api/strapi/aboutPageApi';
import { fetchStrapiData } from '../../api/strapi/utils';

// Action creator to fetch About data from Strapi and update Redux store
export const fetchAboutFromStrapi = (locale) => async (dispatch) => {
  try {
    const result = await getAboutPageData(locale);
    if (!result.ok) {
      if (result.reason !== "NOT_FOUND") {
        console.warn("About data unavailable:", result);
      }
      dispatch(setAboutData(null));
      return;
    }

    const formattedData = formatAboutPageData(result.data);
    dispatch(setAboutData(formattedData));
  } catch (error) {
    console.error('Error fetching About data from Strapi:', error);
    // Optionally dispatch an error state here
  }
};

// Action creator to fetch Contact data from Strapi and update Redux store
export const fetchContactFromStrapi = (locale) => async (dispatch) => {
  try {
    const result = await fetchStrapiData('/global?populate=*', locale);
    if (!result.ok) {
      if (result.reason !== "NOT_FOUND") {
        console.warn("Global data unavailable:", result);
      }
      dispatch(setContactusData(null));
      return;
    }

    const globalData = result.data?.data?.attributes;

    // Format the data to match what the existing components expect
    const formattedData = {
      company: globalData?.siteName || '',
      logo: globalData?.logo?.data?.attributes, // This will be handled by urlFor in the component
      phone: globalData?.phone || '',
      fax: globalData?.fax || '',
      email: globalData?.email || '',
      address: globalData?.address || '',
      postBox: globalData?.postBox || '',
      location: globalData?.location || null
    };

    dispatch(setContactusData(formattedData));
  } catch (error) {
    console.error('Error fetching Contact data from Strapi:', error);
    // Optionally dispatch an error state here
  }
};
